module.exports = __webpack_public_path__ + "img/cutbed.a2984f07.png";